import React from "react";
import AssistantCreateDev from "../../Components/AssistantDev/AssistantCreateDev";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const AssistantCreateDevPage = ({ match, location }) => {
  
    // const query = queryString.parse(location.search);
  
    return (
        
        <React.Fragment>
        {/* <LeftMenu /> */}
            <AssistantCreateDev />
        </React.Fragment>

    );
};

export default AssistantCreateDevPage;
